import { useTranslation } from "react-i18next";
import { getIsWebView } from "../../utils/webView";
import LanguageFlags from "../LanguageFlags";
import Navigation from "../Navigation";
import {
  GameHeaderInner,
  GameHeaderOuter,
  GameHeaderWrapper,
  GameTitle,
  HeaderLogo,
  PlayerImage,
  StickyNavigationWrap,
  StyledClientLogo,
  StyledFantasyLogo,
  TitleSponsorWrap,
  WebViewWrapper,
} from "./styles";

const GameHeader = () => {
  const { t, i18n } = useTranslation();
  const splLink =
    i18n.language === "ar"
      ? "https://www.spl.com.sa/ar"
      : "https://www.spl.com.sa/en";

  if (getIsWebView()) {
    return (
      <WebViewWrapper>
        <Navigation />
        <span id="webview"></span>
      </WebViewWrapper>
    );
  }

  return (
    <>
      <GameHeaderWrapper>
        <GameHeaderOuter>
          <GameHeaderInner>
            <LanguageFlags />
            <PlayerImage />
            <HeaderLogo>
              <a href={splLink} target="_blank" rel="noreferrer">
                <StyledClientLogo
                  title={t("gameHeader.homeLink", "Go to home page")}
                />
              </a>
              <TitleSponsorWrap>
                <GameTitle>
                  <StyledFantasyLogo title="RSL Fantasy" />
                </GameTitle>
              </TitleSponsorWrap>
            </HeaderLogo>
          </GameHeaderInner>
        </GameHeaderOuter>
      </GameHeaderWrapper>
      <StickyNavigationWrap>
        <Navigation />
      </StickyNavigationWrap>
    </>
  );
};

export default GameHeader;
